import { z } from 'zod';
import { Prettify } from '../prettify';

// Local type definitions (previously from fireblocks-xrp-sdk)
export enum TransactionType {
  OFFER_CREATE = 'OFFER_CREATE',
  OFFER_CANCEL = 'OFFER_CANCEL',
  CROSS_CURRENCY_PAYMENT = 'CROSS_CURRENCY_PAYMENT',
}

export interface ExecuteTransactionOpts {
  vaultAccountId: string;
  transactionType: TransactionType | string;
  params: Record<string, any>;
}

export const executeXrpTransactionSchema = z
  .object({
    assetId: z.string(),
  })
  .and(z.custom<ExecuteTransactionOpts>());

export type ExecuteXrplTransactionRequest = Prettify<
  z.infer<typeof executeXrpTransactionSchema>
>;
